import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
import Dev from "@frog/source/models/dev/Dev.js"

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@frog/source/views/components/UnitExperienceBar.jsx"
import "@frog/source/views/components/Unit.less"

export default class Unit {
    render() {
        if((this.props.unit.type == "spot")
        && this.props.unit.properties?.includes("visible") != true
        && Dev.inProtoMode == false) {
            return
        }
        return (
            <div class="Unit" style={this.style} key={this.props.unit.key} isInBounds={this.isInBounds} affiliation={this.props.unit.affiliation}>
                <UnitSprite unit={this.props.unit} isGrayscaled={this.isGrayscaled} index={this.props.index}/>
                <UnitHealthBar stage={this.props.stage} unit={this.props.unit} omegaunit={this.props.omegaunit} maxsegments={20}/>
                {this.props.unit.affiliation == this.props.stage.player?.affiliation && <UnitExperienceBar stage={this.props.stage} unit={this.props.unit}/>}
                {App.game.configuration.alwaysRenderUnitLevel && <div class="UnitLevel">Lv.{this.props.unit.level}</div>}
                <div class="Selection" isHovered={this.isHovered} isSelected={this.isSelected}/>
                <div class="PredictiveDamage">{this.predictiveDamage}</div>
            </div>
        )
        // <div class="UnitElement" element={this.props.unit.element} style={{
        //     "background-color": elements[this.props.unit.element]?.color
        // }}/>
    }
    get predictiveDamage() {
        var predictiveDamage = 0
        if(App.game.chapter.selection.hoveredAction != undefined) {
            App.game.chapter.selection.hoveredAction.steps.forEach((step) => {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage?.flourish != undefined
                    && deltastage.flourish.name == "TextFloat"
                    && deltastage.flourish.unitKey == this.props.unit.key) {
                         const number = Number.parseInt(deltastage.flourish.text)
                         if(Number.isNaN(number) == false) {
                             predictiveDamage += number
                         }
                    }
                })
            })
        }
        if(predictiveDamage != 0) return predictiveDamage
        return ""
    }
    get style() {
        return {
            "left": this.position.x + "em",
            "top": this.position.y + "em",
            "z-index": (this.props.unit.truestack) ?? (1000 + (this.position.y * 100) + (this.props.unit?.stack || 0)), // + (this.position.x)
            "opacity": this.props.unit.opacity, // for death
        }
    }
    get position() {
        // if(App.game.chapter.selection.position.x == this.props.unit.position.x
        // && App.game.chapter.selection.position.y == this.props.unit.position.y) {
        //     return this.props.unit.position
        // }
        // if(App.game.chapter.selection?.selectedUnitKey == this.props.unit.key
        // && App.game.chapter.selection?.hoveredAction?.omegastage != undefined) {
        //     return App.game.chapter.selection.hoveredAction.omegastage.units[this.props.unit.key].position
        // }
        return this.props.unit.position
    }
    get isGrayscaled() {
        if(Dev.inProtoMode == true) return false
        return this.isDone || this.isInBounds == false
    }
    get isDone() {
        if(this.props.unit.affiliation == "bad") return false
        if(this.props.unit.energy == undefined) return false
        return this.props.unit.energy["move"] === false
            && this.props.unit.energy["invoke skill"] === false
    }
    get isInBounds() {
        if(Dev.inProtoMode == true) return true
        if(this.props.stage.flags["ShowAllTheGuysWithoutTransparency"] == true) return true // pirates
        if(this.props.stage.currentEncounterKey == undefined) return false
        if(this.props.stage.encounters[this.props.stage.currentEncounterKey] == undefined) return false
        return Zone.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey].zone, {
            "x": Math.round(this.position.x),
            "y": Math.round(this.position.y),
            "z": Math.round(this.position.z)
        })
    }
    get isHovered() {
        if(Dev.inProtoMode == false) return false
        return this.props.unit.key == App.game.chapter?.selection?.hoveredUnitKey
            || this.props.unit.key == Dev.devSelection.listHoveredUnitKey
    }
    get isSelected() {
        if(Dev.inProtoMode == false) return false
        if(this.props.unit.key == App.game.chapter?.selection?.selectedUnitKey) return true
        if(App.game.chapter?.selection?.multiselectedUnitKeys.includes(this.props.unit.key)) return true
        return false
    }
}
